// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___P5Qp4","seconds_block":"style-module__seconds_block___Df6Oi","seconds_block__title":"style-module__seconds_block__title___SXPZt","seconds_block__seconds":"style-module__seconds_block__seconds___FPCrZ","log_block":"style-module__log_block___IElVj","log_block__device_name":"style-module__log_block__device_name___rV18f","log_block__device_status":"style-module__log_block__device_status___tW1Vf"};
    if(module.hot) {
      // 1729151133282
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  